import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  ModalBody,
} from "@chakra-ui/react";

export const VideoModal = ({
  isOpen,
  onClose,
  videoUrl,
}: {
  isOpen: boolean;
  onClose: () => void;
  videoUrl: string;
}) => {
  if (!videoUrl) return null;
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      size="4xl"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody
          p={0}
          w={"full"}
          h={{
            base: "full",
            md: "600px",
          }}
          minH={{
            base: "full",
            md: "600px",
          }}
        >
          <iframe
            src={videoUrl}
            title="Video"
            width="100%"
            height="600px"
            frameBorder="0"
            allowFullScreen
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
